@import '../../sass/components/tooltip';

.visible {
  display: inline;
  visibility: visible;
}